import { giphyDarkestGrey } from '@giphy/colors'
import { ControlSize } from 'types'

export const SIDEBAR_COLOR = giphyDarkestGrey
export const SIDEBAR_PRESET_SIZE: ControlSize = 'medium'
export const SIDEBAR_GAP = 5
